import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CustomerService } from 'src/app/customer/customer.service';
import { LeadDataModel } from 'src/app/lead/lead-data-model';
import { ContactFormDialogComponent } from '../add-contact/contact-form-dialog/contact-form-dialog.component';
import { CommonDataModel } from '../common-data-model';
import { LeadEditFormPopupComponent } from '../lead-edit-form-popup/lead-edit-form-popup.component';
import { MarkupsListComponent } from '../markups-list/markups-list.component';
import { CommonMethod } from 'src/app-core/methods/common-methods';

@Component({
    selector: 'app-lead-account-details-popup',
    templateUrl: './lead-account-details-popup.component.html',
    styleUrls: ['./lead-account-details-popup.component.scss']
})
export class LeadAccountDetailsPopupComponent implements OnInit {

    @ViewChild('MarkupsListComponent', { static: false }) MarkupsListComponent: MarkupsListComponent;
    leadData: any;
    leadDataModel = new LeadDataModel();
    leadDetails: any = this.leadDataModel.leadDetailsModel;
    commonDataModel = new CommonDataModel();
    contactListParams = this.commonDataModel.contactListParamsModel;
    summaryList = this.leadDataModel.summaryModel;
    hideDetails = true;
    leadId: string;
    isDetailLoading = true;
    statusList = [];
    contactId: number;
    contactGuidId: string;
    isFirstTimeAddressLoad = true;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<LeadAccountDetailsPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private toastr: ToastrService,
        private accountService: CustomerService,
        private customerService: CustomerService,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private contactService: ContactService) {
    }

    ngOnInit(): void {
        this.leadData = this.data;
        this.leadId = this.leadData.leadId;
        this.getCustomer();
        this.getStatus();
    }

    getStatus() {
        this.accountService.getAccountStatusList().subscribe((response: any) => {
            if (response.isSuccess) {
                this.statusList = response.data;
            } else {
                this.toastr.error(response.errors || 'Something went wrong please Re-try');
            }
        });
    }

    getCustomer(): void {
        this.customerService.getAccount(this.leadId).subscribe(response => {
            this.commonMethod.sendIsAccountId(response.data.accountId);
            this.leadDetails = response.data;
            this.commonService.objectMapping(this.contactListParams, this.leadDetails);
            this.isDetailLoading = false;
        });
    }

    getContactsCount(event: number) {
        this.summaryList.contactsCount = event;
    }

    getAddressesCount(event: any) {
        this.summaryList.addressesCount = event;
        if (!this.isFirstTimeAddressLoad && event.isUpdate) {
            this.contactGuidId = this.leadDetails.contactId;
            this.updateAccountCall();
        } else if (this.isFirstTimeAddressLoad) {
            this.isFirstTimeAddressLoad = false;
        }
    }

    onExpandDetails(): void {
        this.hideDetails = !this.hideDetails;
    }

    onEditLead(): void {
        this.dialog.open(LeadEditFormPopupComponent, {
            position: {
                top: '60px',
                left: '60px'
            },
            panelClass: ['small_layout', 'details_layout'],
            hasBackdrop: false,
            autoFocus: false,
            data: { accountId: this.leadDetails.accountId }
        }).afterClosed()
            .subscribe((response: any) => {
                if (response.success) {
                    this.contactGuidId = this.leadDetails.contactId;
                    this.updateAccountCall();
                }

            });
    }

    updateAccountCall(): void {
        this.isDetailLoading = true;
        this.contactService.getRecord(this.contactGuidId)
            .subscribe(contactResponse => {
                if (contactResponse.isSuccess) {
                    if (this.contactId) {
                        contactResponse.data.contactId = this.contactId;
                    } else {
                        contactResponse.data.contactId = this.leadDetails.contactId;
                        contactResponse.data.accountDisplayId = this.leadDetails.accountDisplayId;
                    }
                    contactResponse.data.accountName = contactResponse.data.associatedAccountName;
                    contactResponse.data.id = contactResponse.data.accountId;
                    const sendingData = {
                        success: true,
                        data: contactResponse.data
                    };
                    this.isDetailLoading = false;
                    this.dialogRef.close(sendingData);
                }
            });
    }

    emitMarkups(event: any) {
        this.summaryList.markupsCount = this.MarkupsListComponent.gridItems.total;
    }

    onBoxMappingEmit(event: any) {
        this.summaryList.boxMapping = event;
    }

    onOpenEditContact(event: any) {
        this.isDetailLoading = true;
        this.contactService.getRecord(event.contactId)
            .subscribe(response => {
                this.isDetailLoading = false;
                this.contactGuidId = event.contactId;
                this.contactId = parseInt(response.data.contactDisplayId.split('-')[1]);
                response.data.accountName = response.data.associatedAccountName;
                this.openEditContact(event.contactId, response.data);
            });
    }

    openEditContact(contId, contactDetails) {
        this.dialog.open(ContactFormDialogComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            data: {
                contactId: contId,
                isEdit: true,
                accountName: contactDetails.accountName,
                accountId: contactDetails.accountId,
                accountTypeId: contactDetails.accountTypeId || 1
            },
        }).afterClosed().subscribe((response: any) => {
            if (response) {
                this.updateAccountCall();
            }
        });
    }

    onGoBack(): void {
        this.onClose();
    }

    onSave() {
        const sendingData = {};
        this.dialogRef.close(sendingData);
    }

    onCloseDialog(ev: any) {
        this.onClose();
    }

    onClose(): void {
        this.dialogRef.close(false);
    }

    onScroll(el: HTMLElement): void {
        el.scrollIntoView({ behavior: 'smooth' });
    }

}
